module.exports = __webpack_public_path__ + "static/img/3330_phase_function_Paper_PointsHejduk_Prediction.722a059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3330_phase_function_Paper_PointsHejduk_Prediction.png
// module id = CMKH
// module chunks = 0